import { Button } from 'blaze-ui/Button'
import { Menu } from 'components/Menu/Menu'
import { SelectableItem } from 'components/Menu/MenuItem'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { ASPECT_RATIOS, AspectRatioKey } from 'components/NewFileModal/Types'
import Styles from '../TemplatesV2.module.scss'
import { useVisualTemplates } from 'hooks/useVisualTemplates'
import { collectResults } from 'utils/query'

interface Props {
  initialAspectRatioKey: AspectRatioKey
  onChange: (aspectRatioKey: AspectRatioKey, templateId: number) => void
  initialTemplateId: number
  templateBinderId: number
}

type MenuKey = `${AspectRatioKey}:${number}`

export const AspectRatioKeyMenu = ({ initialAspectRatioKey, onChange, templateBinderId, initialTemplateId }: Props) => {
  const { width, height, name, icon: Icon } = ASPECT_RATIOS[initialAspectRatioKey]

  const templatesForSameBinderQuery = useVisualTemplates({
    template_binder_id: templateBinderId,
    order_by: 'random',
    items: 50,
  })
  const templates = collectResults(templatesForSameBinderQuery, (data) => data.visual_elements)

  const initialAspectRatio = { width, height, templateId: initialTemplateId }
  const aspectRatiosForSameBinder = templates.map((template) => ({
    width: template.width,
    height: template.height,
    templateId: template.id,
  }))

  let selectableAspectRatios = [initialAspectRatio].concat(aspectRatiosForSameBinder).flatMap((selectableAspectRatio) =>
    Object.entries(ASPECT_RATIOS)
      .filter(
        ([_, designAspectRatio]) =>
          designAspectRatio.width === selectableAspectRatio.width &&
          designAspectRatio.height === selectableAspectRatio.height,
      )
      .map(([aspectRatioKey, _]) => ({ aspectRatioKey, templateId: selectableAspectRatio.templateId })),
  )

  selectableAspectRatios = Array.from(
    new Map(selectableAspectRatios.map((item) => [`${item.aspectRatioKey}:${item.templateId}`, item])).values(),
  ).sort((a, b) => a.aspectRatioKey.localeCompare(b.aspectRatioKey))

  const handleAction = (key: MenuKey) => {
    const [aspectRatioKey, templateId] = key.split(':')
    onChange(aspectRatioKey as AspectRatioKey, parseInt(templateId))
  }

  return (
    <MenuTrigger>
      <div className={Styles.aspectRatioKeyButtonContainer}>
        <Button variant="secondary" fullWidth withChevron="down">
          <div className={Styles.aspectRatioKeyButton}>
            <Icon size={20} />
            {name}
          </div>
        </Button>
      </div>
      <Menu onAction={(key) => handleAction(key as MenuKey)}>
        {selectableAspectRatios.map((selectableAspectRatio) => {
          const { icon: Icon, name } = ASPECT_RATIOS[selectableAspectRatio.aspectRatioKey as AspectRatioKey]

          return (
            <SelectableItem
              type="item"
              key={`${selectableAspectRatio.aspectRatioKey}:${selectableAspectRatio.templateId}`}
              textValue={name}
            >
              <Icon />
              {name}
            </SelectableItem>
          )
        })}
      </Menu>
    </MenuTrigger>
  )
}
